import type { ReactNode } from "react";

import {
  AutoAllowCookiesProvider,
  CookieInformationProvider,
} from "@provider/consent";

type Props = {
  siteId: string;
  children: ReactNode;
};

export function CookieConsentProvider(props: Props) {
  if (props.siteId === "11755011-41e4-485c-aaaa-74fb95fa99fc") {
    return (
      <CookieInformationProvider>{props.children}</CookieInformationProvider>
    );
  }

  return <AutoAllowCookiesProvider>{props.children}</AutoAllowCookiesProvider>;
}
